import { useEffect, useState } from 'react';
import { getPodcastConfig } from './podcastApi';
import { FALLBACK_CONFIG, normalizeConfig } from './podcastJob';

// Opcje kreatora z GET /api/public/config; przy błędzie stałe wartości z kontraktu.
const usePodcastConfig = () => {
  const [state, setState] = useState({ config: null, loading: true, fallback: false });

  useEffect(() => {
    let active = true;
    getPodcastConfig()
      .then((data) => {
        if (active) setState({ config: normalizeConfig(data), loading: false, fallback: false });
      })
      .catch(() => {
        if (active) setState({ config: normalizeConfig(FALLBACK_CONFIG), loading: false, fallback: true });
      });
    return () => {
      active = false;
    };
  }, []);

  return state;
};

export default usePodcastConfig;
